import { PureComponent } from 'react';

import { User } from 'src/components/types';
import { UserAvatar } from 'src/containers/user-avatar';
import { UserName } from 'src/containers/user-name';

import * as styles from './details-list.style';

type WatcherListItemProps = {
  item: User;
};

export default class WatcherListItem extends PureComponent<WatcherListItemProps> {
  render() {
    const { item: user } = this.props;

    return (
      <styles.ListItem>
        <styles.ListItemAvatar>
          <UserAvatar
            profileCardPosition="bottom-start"
            size="small"
            user={user}
          />
        </styles.ListItemAvatar>
        <UserName
          linkComponent={styles.ListItemLink}
          profileCardPosition="bottom-start"
          user={user}
        />
      </styles.ListItem>
    );
  }
}
